"use strict";
/*
 * Created on 09 01 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var ValidationResult_1 = require("../../core/model/errors/ValidationResult");

var PriceWithValidity_1 = require("../../product/model/PriceWithValidity");

var ProductPurchasePrice_1 = require("../../product/model/ProductPurchasePrice");

var ZonePrices_1 = require("../../product/model/ZonePrices"); //tslint:disable:max-classes-per-file

/**
 * <p>An item re-priced during a @{SiteRelease release}. It represents an assignment of a price to a product and a site.</p>
 *
 * <p><b>The entity contains some reference to other data, such as {@link Family}, {@link ProductSensitivity}. These information are
 * currently set only during initial items creation, they are not synchronized within the release lifecycle. It should not be needed,
 * because lifecycle of the type of release should be very short.</b></p>
 *
 * @author Jaroslav Sevcik
 * @author JMe
 */


var SiteReleaseItem =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SiteReleaseItem, _DomainObject_1$Domai);

  /**
   * @param id Corresponds to {@link IPriceReleaseItem.id}.
   * @param releaseId Corresponds to {@link IPriceReleaseItem.releaseId}.
   * @param productId Corresponds to {@link IPriceReleaseItem.productId}.
   * @param productExternalId Corresponds to {@link IPriceReleaseItem.productExternalId}.
   * @param productName Corresponds to {@link IPriceReleaseItem.productName}. The value corresponds to the time of an item creation.
   * @param siteId Corresponds to {@link InternalSite.id}.
   * @param siteExtId Corresponds to {@link InternalSite.externalId}.
   * @param siteName Corresponds to {@link InternalSite.name}. The value corresponds to the time of an item creation.
   * @param exported Corresponds to {@link IPriceReleaseItem.exported}.
   * @param exportedDate Corresponds to {@link IPriceReleaseItem.exportedDate}.
   * @param price The value of price which should be used for repricing.
   * @param tierId Corresponds to {@link Tier.id} to which a product belonged at the time of an item creation.
   * @param productSensitivityId Corresponds to {@link ProductSensitivity.id} to which a product belonged at the time of an item creation.
   * @param supplierId Corresponds to {@link Supplier.id}. Represents the preferred supplier (if any) at the time of an item creation.
   * @param familyId Corresponds to {@link Family.id}. Represents the family to which a product belonged at the time of an item creation.
   * @param categoryIds The list of category ids (tree) to which a product belongs at the time of an item creation. The list may contain
   *        only subset of category tree to which a product belongs, but it should always be true that the list includes categories
   *        ordered from the lowest level to the higher.
   * @param purchasePrice The aggregated value of purchase price (PP) without VAT (which does not have date-to), simple average in case
   *        of more suppliers. The value is not currently dependant on {@link PriceZone}.
   * @param zonePrices The list of {@link ZonePrices}. The list contains data for all not archived zones at the time of an item creation.
   * @param validation Validation result related to the item. The value is result of validation.
   */
  function SiteReleaseItem(id, releaseId, productId, productExternalId, productName, siteId, siteExtId, siteName, exported, exportedDate, price, tierId, productSensitivityId, supplierId, familyId, categoryIds, purchasePrice, zonePrices, validation) {
    var _this;

    _classCallCheck(this, SiteReleaseItem);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SiteReleaseItem).call(this));
    _this.id = id;
    _this.releaseId = releaseId;
    _this.productId = productId;
    _this.productExternalId = productExternalId;
    _this.productName = productName;
    _this.siteId = siteId;
    _this.siteExtId = siteExtId;
    _this.siteName = siteName;
    _this.exported = exported;
    _this.exportedDate = exportedDate;
    _this.price = price;
    _this.tierId = tierId;
    _this.productSensitivityId = productSensitivityId;
    _this.supplierId = supplierId;
    _this.familyId = familyId;
    _this.categoryIds = categoryIds;
    _this.purchasePrice = purchasePrice;
    _this.zonePrices = zonePrices;
    _this.validation = validation;
    return _this;
  }

  return SiteReleaseItem;
}(DomainObject_1.DomainObject);

exports.SiteReleaseItem = SiteReleaseItem;

SiteReleaseItem.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SiteReleaseItem.name);
  return {
    id: builder.id('id'),
    releaseId: builder.str('releaseId'),
    productId: builder.str('productId'),
    productExternalId: builder.str('productExternalId'),
    productName: builder.str('productName'),
    siteId: builder.str('siteId'),
    siteExtId: builder.str('siteExtId'),
    siteName: builder.str('siteName'),
    exported: builder.bool('exported'),
    exportedDate: builder.opt(builder.date('exportedDate', DateParser_1.DateParser.ISO_PATTERN)),
    price: builder.obj('price', PriceWithValidity_1.PriceWithValidity.schema, function (mat) {
      return PriceWithValidity_1.PriceWithValidity.fromDataDict(mat);
    }),
    tierId: builder.str('tierId'),
    productSensitivityId: builder.str('productSensitivityId'),
    supplierId: builder.opt(builder.str('supplierId')),
    familyId: builder.opt(builder.str('familyId')),
    categoryIds: builder.listOf(builder.id('categoryIds')),
    purchasePrice: builder.opt(builder.obj('purchasePrice', ProductPurchasePrice_1.ProductPurchasePrice.schema, function (mat) {
      return ProductPurchasePrice_1.ProductPurchasePrice.fromDataDict(mat);
    })),
    zonePrices: builder.listOf(builder.obj('zonePrices', ZonePrices_1.ZonePrices.schema, function (mat) {
      return ZonePrices_1.ZonePrices.fromDataDict(mat);
    })),
    validation: builder.obj('validation', ValidationResult_1.ValidationResult.schema, function (mat) {
      return new ValidationResult_1.ValidationResult(mat.resultObjects);
    })
  };
}();
/**
 * <p>Represents some aggregated metadata from {@link SiteReleaseItem items}. These data are aggregated on release level.</p>
 *
 * @author JMe
 */


var SiteReleaseItemMetadata =
/**
 * Ctor.
 *
 * @param minPriceValidFrom Minimum value of price validity start of all items (non only exported ones).
 * @param minExportedDate Minimum value of {@link SiteReleaseItem.exportedDate}. Null means none item was exported.
 */
function SiteReleaseItemMetadata(minPriceValidFrom, minExportedDate) {
  _classCallCheck(this, SiteReleaseItemMetadata);

  this.minPriceValidFrom = minPriceValidFrom;
  this.minExportedDate = minExportedDate;
};

exports.SiteReleaseItemMetadata = SiteReleaseItemMetadata;
/**
 * <p>Immutable implementation of {@link SiteReleaseItemPriceUpdateInputPartial}</p>
 * <p>The main purpose of this representation is to provide capability of PATCH request related to the entire entity.</p>
 *
 * @author JMe
 */

var SiteReleaseItemPriceUpdateInput =
/*#__PURE__*/
function (_DomainObject_1$Domai2) {
  _inherits(SiteReleaseItemPriceUpdateInput, _DomainObject_1$Domai2);

  /**
   * Ctor.
   *
   * @param id Corresponds to {@link SiteReleaseItem.id}.
   * @param price Corresponds to {@link SiteReleaseItem.price}.
   * @param validation Corresponds to {@link SiteReleaseItem.validation}.
   */
  function SiteReleaseItemPriceUpdateInput(id, price, validation) {
    var _this2;

    _classCallCheck(this, SiteReleaseItemPriceUpdateInput);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(SiteReleaseItemPriceUpdateInput).call(this));
    _this2.id = id;
    _this2.price = price;
    _this2.validation = validation;
    return _this2;
  }

  return SiteReleaseItemPriceUpdateInput;
}(DomainObject_1.DomainObject);

exports.SiteReleaseItemPriceUpdateInput = SiteReleaseItemPriceUpdateInput;
/**
 * <p>Immutable implementation of {@link SiteReleaseItemPriceUpdateOutputPartial}</p>
 * <p>This entity has single purpose, serves as update object of {@link SiteReleaseItem.price}.</p>
 *
 * @author JMe
 */

var SiteReleaseItemPriceUpdateOutput =
/*#__PURE__*/
function (_DomainObject_1$Domai3) {
  _inherits(SiteReleaseItemPriceUpdateOutput, _DomainObject_1$Domai3);

  /**
   * Ctor.
   *
   * @param id Corresponds to {@link SiteReleaseItem.id}.
   * @param price Corresponds to {@link SiteReleaseItem.price}.
   * @param exported Corresponds to {@link SiteReleaseItem.exported}. Modeled as optional since it is updated only in case of
   *        validation errors.
   * @param validation Corresponds to {@link SiteReleaseItem.validation}. Modeled as optional since it is updated only if required.
   */
  function SiteReleaseItemPriceUpdateOutput(id, price, exported, validation) {
    var _this3;

    _classCallCheck(this, SiteReleaseItemPriceUpdateOutput);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(SiteReleaseItemPriceUpdateOutput).call(this));
    _this3.id = id;
    _this3.price = price;
    _this3.exported = exported;
    _this3.validation = validation;
    return _this3;
  }

  return SiteReleaseItemPriceUpdateOutput;
}(DomainObject_1.DomainObject);

exports.SiteReleaseItemPriceUpdateOutput = SiteReleaseItemPriceUpdateOutput;
/**
 * <p>Immutable implementation of {@link SiteReleaseItemPriceValidFromPartial}</p>
 * <p>The main purpose of this representation is to provide capability of PATCH request related to the entire entity.</p>
 *
 * @author JMe
 */

var SiteReleaseItemPriceValue =
/*#__PURE__*/
function (_DomainObject_1$Domai4) {
  _inherits(SiteReleaseItemPriceValue, _DomainObject_1$Domai4);

  /**
   * Ctor.
   *
   * @param id Corresponds to {@link SiteReleaseItem.id}.
   * @param value Corresponds to {@link PriceWithValidity.value} of {@link SiteReleaseItem.price}.
   */
  function SiteReleaseItemPriceValue(id, value) {
    var _this4;

    _classCallCheck(this, SiteReleaseItemPriceValue);

    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(SiteReleaseItemPriceValue).call(this));
    _this4.id = id;
    _this4.value = value;
    return _this4;
  }

  return SiteReleaseItemPriceValue;
}(DomainObject_1.DomainObject);

exports.SiteReleaseItemPriceValue = SiteReleaseItemPriceValue;
/**
 * <p>Immutable implementation of {@link SiteReleaseItemPriceValidFromPartial}</p>
 * <p>The main purpose of this representation is to provide capability of PATCH request related to the entire entity.</p>
 *
 * @author JMe
 */

var SiteReleaseItemPriceValidFrom =
/*#__PURE__*/
function (_DomainObject_1$Domai5) {
  _inherits(SiteReleaseItemPriceValidFrom, _DomainObject_1$Domai5);

  /**
   * Ctor.
   *
   * @param id Corresponds to {@link SiteReleaseItem.id}.
   * @param validFrom Corresponds to {@link PriceWithValidity.validFrom} of {@link SiteReleaseItem.price}.
   */
  function SiteReleaseItemPriceValidFrom(id, validFrom) {
    var _this5;

    _classCallCheck(this, SiteReleaseItemPriceValidFrom);

    _this5 = _possibleConstructorReturn(this, _getPrototypeOf(SiteReleaseItemPriceValidFrom).call(this));
    _this5.id = id;
    _this5.validFrom = validFrom;
    return _this5;
  }

  return SiteReleaseItemPriceValidFrom;
}(DomainObject_1.DomainObject);

exports.SiteReleaseItemPriceValidFrom = SiteReleaseItemPriceValidFrom;
/**
 * <p>Immutable implementation of {@link SiteReleaseItemExportedPartial}</p>
 * <p>The main purpose of this representation is to provide capability of PATCH request related to the entire entity.</p>
 *
 * @author JMe
 */

var SiteReleaseItemExported =
/*#__PURE__*/
function (_DomainObject_1$Domai6) {
  _inherits(SiteReleaseItemExported, _DomainObject_1$Domai6);

  /**
   * Ctor.
   *
   * @param id Corresponds to {@link SiteReleaseItem.id}.
   * @param exported Corresponds to {@link SiteReleaseItem.exported}.
   */
  function SiteReleaseItemExported(id, exported) {
    var _this6;

    _classCallCheck(this, SiteReleaseItemExported);

    _this6 = _possibleConstructorReturn(this, _getPrototypeOf(SiteReleaseItemExported).call(this));
    _this6.id = id;
    _this6.exported = exported;
    return _this6;
  }

  return SiteReleaseItemExported;
}(DomainObject_1.DomainObject);

exports.SiteReleaseItemExported = SiteReleaseItemExported;